import React, { Dispatch, SetStateAction, useContext } from "react";
import MultiStepForm from "./MultiStepForm";
import CategoryForm from "./CategoryForm";
import AddressForm from "./AddressForm";
import Success from "./Success";
import SchedullingConfirmation from "./SchedullingConfirmation";
import { MultiSelectFormContext } from "~/contexts/MultiSelectForm";

import "bootstrap/dist/css/bootstrap-grid.min.css";
import "bootstrap/dist/css/bootstrap-utilities.min.css";

type BookFormProps = {
    utmSource: string;
    currentStep: number;
    setCurrentStep: Dispatch<SetStateAction<number>>;
};

const BookForm = ({ utmSource, currentStep, setCurrentStep }: BookFormProps) => {
    const { totalSteps } = useContext(MultiSelectFormContext);

    const nextStep = () => {
        if (currentStep >= totalSteps) return;

        const step = currentStep + 1;

        const params = new URLSearchParams(window.location.search);
        params.set("step", step.toString());

        window.history.pushState({ step }, "", `/marketplace/book?${params.toString()}`);

        setCurrentStep(step);
    };

    const prevStep = () => {
        if (currentStep <= 1) return;

        const step = currentStep - 1;

        const params = new URLSearchParams(window.location.search);
        params.set("step", step.toString());

        window.history.pushState({ step }, "", `/marketplace/book?${params.toString()}`);

        setCurrentStep(step);
    };

    const goToStep = (step: number) => {
        if (currentStep <= 0) return;

        const params = new URLSearchParams(window.location.search);
        params.set("step", step.toString());

        window.history.pushState({ step }, "", `/marketplace/book?${params.toString()}`);

        setCurrentStep(step);
    };

    return (
        <MultiStepForm currentStep={currentStep} nextStep={nextStep} prevStep={prevStep} goToStep={goToStep} utmSource={utmSource}>
            <CategoryForm />
            <AddressForm />
            <SchedullingConfirmation />
            <Success />
        </MultiStepForm>
    );
};

export default BookForm;
